import { motion } from "framer-motion";
import { STEPS } from "@/data";
import { stepDemo } from "@/components/ProcessDemos";

const ease = [0.16, 1, 0.3, 1];

function Step({ step, i }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.9, delay: i * 0.1, ease }}
            className="flex flex-col border-l border-white/15 pl-6 lg:pl-7"
            data-testid={`process-step-${step.index}`}
        >
            <div
                className="relative aspect-[4/5] overflow-hidden sm:aspect-[4/3] lg:aspect-[4/5] xl:aspect-[4/4.6]"
                data-testid={`process-step-image-${step.index}`}
            >
                {stepDemo(step)}
                <span className="pointer-events-none absolute left-4 top-3 font-display text-5xl font-light leading-none text-[#FAF8F5] drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)] lg:text-6xl">
                    {step.index}
                </span>
            </div>
            <div className="pt-7">
                <h3 className="font-display text-4xl font-light leading-none tracking-tight text-[#FAF8F5] lg:text-5xl">
                    {step.word}
                    <span className="text-white/30">.</span>
                </h3>
                <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-white/65">
                    {step.text}
                </p>
            </div>
        </motion.div>
    );
}

export default function Process() {
    return (
        <section
            id="process"
            className="bg-[#121211] px-6 py-24 lg:px-10 lg:py-32"
            data-testid="process-section"
        >
            <div className="mx-auto max-w-[1400px]">
                <div className="flex flex-col justify-between gap-4 border-b border-white/10 pb-8 lg:flex-row lg:items-end">
                    <div>
                        <p className="font-mono2 text-[10px] uppercase tracking-[0.34em] text-white/50">
                            How an experience works
                        </p>
                        <h2 className="mt-4 font-display text-3xl font-light leading-tight tracking-tight text-[#FAF8F5] sm:text-4xl">
                            More than photography. <span className="text-white/40">Try it.</span>
                        </h2>
                    </div>
                    <p
                        className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-white/50"
                        data-testid="process-progression"
                    >
                        Move → Look → Discover → Act
                    </p>
                </div>

                <div
                    className="mt-14 grid gap-12 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4 lg:gap-8"
                    data-testid="process-track"
                >
                    {STEPS.map((s, i) => (
                        <Step key={s.index} step={s} i={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
